module.exports = [{"name":"PSaaS Terms","papers":[{"title":"PSaaS Terms","id":"psaas-terms","icon":"https://cdn.auth0.com/website/assets/pages/legals/img/icon-acrobat-7d1807772f.svg","date":"January, 2019","actions":[{"action":"download","file":"https://cdn.auth0.com/website/legal/files/auth0-psaas-19.pdf"},{"action":"open","file":"https://cdn.auth0.com/website/legal/files/auth0-psaas-19.pdf"}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/psaas/data/psaasPapers.json
// module id = 1653
// module chunks = 0